import { forwardRef, ReactNode, ElementType } from 'react';

import { RecipeVariants } from '@vanilla-extract/recipes';

import { boxRecipe } from './Box.css';
import { getClassNames } from '../../util/css';
import { BackgroundRecipeVariants, backgroundRecipe } from '../../util/css/vanilla-extract/shared/background.css';
import {
  BorderColorRecipeVariants,
  borderColorRecipe,
  BorderRadiusRecipeVariants,
  borderRadiusRecipe,
  BorderWidthRecipeVariants,
  borderWidthRecipe,
} from '../../util/css/vanilla-extract/shared/border.css';
import { PaddingRecipeVariants, paddingRecipe } from '../../util/css/vanilla-extract/shared/padding.css';

const sparkyBoxClassName = 'sparky-box';

export const Box = forwardRef<HTMLDivElement, BoxProps>(
  (
    {
      as: TagName = 'div',
      backgroundColor,
      borderRadius,
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
      borderColor,
      borderWidth,
      children,
      className = '',
      id,
      overflow,
      padding,
      paddingBottom,
      paddingLeft,
      paddingRight,
      paddingTop,
      paddingX,
      paddingY,
      role,
    },
    ref,
  ) => {
    const classNames = getClassNames(
      sparkyBoxClassName,
      backgroundRecipe({ backgroundColor }),
      boxRecipe({ overflow }),
      paddingRecipe({ padding, paddingBottom, paddingLeft, paddingRight, paddingTop, paddingX, paddingY }),
      borderRadiusRecipe({
        borderRadius,
        borderTopLeftRadius,
        borderTopRightRadius,
        borderBottomLeftRadius,
        borderBottomRightRadius,
      }),
      borderWidthRecipe({ borderWidth }),
      borderColorRecipe({ borderColor }),
      className,
    );

    return (
      <TagName className={classNames} id={id} ref={ref} role={role}>
        {children}
      </TagName>
    );
  },
);

Box.toString = () => `.${sparkyBoxClassName}`;
Box.displayName = 'Box';

type BoxProps = RecipeVariants<typeof boxRecipe> &
  BackgroundRecipeVariants &
  BorderColorRecipeVariants &
  BorderRadiusRecipeVariants &
  BorderWidthRecipeVariants &
  PaddingRecipeVariants & {
    /** The DOM element to render*/
    as?: ElementType;
    children?: ReactNode;
    className?: string;
    id?: string;
    role?: string;
  };
